var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"whatsbtn-group",attrs:{"id":"wtsbtn"}},[_c('a',{staticClass:"whatsbtn-button hvr-grow",attrs:{"role":"button","target":"_blank","href":"https://wa.me/551137402110?text=Olá! eu estou no site cursinho.cpv.com.br e preciso de atendimento.","aria-describedby":"whatsbtn-button-label"}},[_c('i',{staticClass:"fab fa-whatsapp whatsbtn-icon"})])])
}]

export { render, staticRenderFns }